import { Box, Button, styled, Typography } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(25),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1),
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledStateTypography = styled(Typography)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    fontSize: '12px',
    color: disabled ? theme.palette.grey[400] : theme.palette.grey[200],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  })
);

export const StyledIconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: 0,
  padding: 0,
  minWidth: 'auto',
  color: theme.palette.grey[200],
  '&:hover': {
    color: theme.palette.grey[100],
  },
  '& .MuiButton-startIcon': {
    margin: 0,
  },
}));
